export const seoConfig = {
  homePage: {
    title: "AI Fundraising & Advocacy Campaign Tools | ReachThePeople.ai",
    canonical: "https://reachthepeople.ai/",
    description:
      "ReachThePeople.ai offers AI-powered outreach and fundraising tools designed specifically for political and advocacy campaigns.",
    keywords:
      "Political campaign tools, Advocacy campaign AI, AI fundraising, AI-powered outreach, Campaign communication tools, Political tech, Digital advocacy, AI campaign strategy",
    og: {
      title:
        "AI Fundraising & Advocacy Tools for Campaigns | ReachThePeople.ai",
      description:
        "Personalize outreach, boost fundraising, and track supporter sentiment in real time. Built for political & advocacy teams.",
      url: "https://reachthepeople.ai/",
      type: "website",
      siteName: "ReachThePeople.ai",
    },
    twitter: {
      title: "AI Fundraising & Advocacy Campaign Tools",
      description:
        "AI-powered outreach and fundraising tools designed specifically for political and advocacy campaigns.",
      card: "summary_large_image",
    },
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://reachthepeople.ai/#org",
          name: "ReachThePeople.ai",
          url: "https://reachthepeople.ai/",
          sameAs: ["https://www.instagram.com/reachthepeople_ai/"],
        },
        {
          "@type": "WebSite",
          "@id": "https://reachthepeople.ai/#website",
          url: "https://reachthepeople.ai/",
          name: "ReachThePeople.ai",
          publisher: { "@id": "https://reachthepeople.ai/#org" },
          inLanguage: "en",
        },
        {
          "@type": "WebPage",
          "@id": "https://reachthepeople.ai/#webpage",
          url: "https://reachthepeople.ai/",
          name: "AI Fundraising & Advocacy Campaign Tools",
          isPartOf: { "@id": "https://reachthepeople.ai/#website" },
          description:
            "Build connections, boost fundraising, and track supporter sentiment in real time.",
          breadcrumb: { "@id": "https://reachthepeople.ai/#breadcrumbs" },
          inLanguage: "en",
        },

        /* Legacy app node you already had; safe to keep or remove */
        {
          "@type": "SoftwareApplication",
          "@id": "https://reachthepeople.ai/#app",
          name: "ReachThePeople.ai",
          applicationCategory: "MarketingApplication",
          operatingSystem: "Web",
          url: "https://reachthepeople.ai/",
        },

        /* New: Chrome extension as a WebApplication */
        {
          "@type": "WebApplication",
          "@id": "https://reachthepeople.ai/#webapp",
          name: "ReachThePeople.ai",
          alternateName: "ReachThePeople.ai - helping campaigns win with AI",
          url: "https://reachthepeople.ai/",
          applicationCategory: "BrowserApplication",
          applicationSubCategory: "ChromeExtension",
          operatingSystem: "Windows, macOS, Linux, ChromeOS",
          browserRequirements:
            "Requires Google Chrome or a Chromium-based browser that supports the Chrome Web Store.",
          installUrl:
            "https://chromewebstore.google.com/detail/reachthepeopleai-helping/fcfdgabjkkablkbgmlgmnplpgnfnmabn",
          downloadUrl:
            "https://chromewebstore.google.com/detail/reachthepeopleai-helping/fcfdgabjkkablkbgmlgmnplpgnfnmabn",
          softwareVersion: "1.0.1",
          dateModified: "2025-08-05",
          fileSize: "3.62 MiB",
          inLanguage: "en-US",
          isAccessibleForFree: true,
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
            availability: "https://schema.org/InStock",
            url: "https://chromewebstore.google.com/detail/reachthepeopleai-helping/fcfdgabjkkablkbgmlgmnplpgnfnmabn",
          },
          publisher: { "@id": "https://reachthepeople.ai/#org" },
          potentialAction: {
            "@type": "InstallAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate:
                "https://chromewebstore.google.com/detail/reachthepeopleai-helping/fcfdgabjkkablkbgmlgmnplpgnfnmabn",
            },
          },
        },

        {
          "@type": "BreadcrumbList",
          "@id": "https://reachthepeople.ai/#breadcrumbs",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://reachthepeople.ai/",
            },
          ],
        },
      ],
    },
  },
  blogsPage: {
    title: "Blogs: AI Outreach, Fundraising & Advocacy | ReachThePeople.ai",
    canonical: "https://reachthepeople.ai/blogs",
    description:
      "Insights for campaign professionals and nonprofits.AI-powered outreach, donor intelligence, voter engagement, and messaging strategy. Practical playbooks, case studies, and trends.",
    keywords:
      "campaign blogs, AI fundraising, political outreach, advocacy strategy, supporter sentiment, donor engagement, email automation, SMS outreach",
    og: {
      title: "Blogs: AI Outreach, Fundraising & Advocacy",
      description:
        "AI-powered outreach & fundraising insights for campaigns and nonprofits.",
      url: "https://reachthepeople.ai/blogs",
      type: "website",
      siteName: "ReachThePeople.ai",
    },
    twitter: {
      title: "Blogs: AI Outreach, Fundraising & Advocacy",
      description: "Playbooks, case studies, and trends for campaign pros.",
      card: "summary_large_image",
    },
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://reachthepeople.ai/blogs#webpage",
          url: "https://reachthepeople.ai/blogs",
          name: "Blogs",
          description:
            "Insights for campaigns and nonprofits on AI-powered outreach, fundraising, and voter engagement.",
          isPartOf: { "@id": "https://reachthepeople.ai/#website" },
          inLanguage: "en",
        },
        {
          "@type": "CollectionPage",
          "@id": "https://reachthepeople.ai/blogs#collection",
          name: "Blogs Index",
          url: "https://reachthepeople.ai/blogs",
          about:
            "AI outreach, fundraising, advocacy strategy, and supporter outreach",
          isPartOf: { "@id": "https://reachthepeople.ai/#website" },
          mainEntity: { "@id": "https://reachthepeople.ai/blogs#blog" },
          inLanguage: "en",
        },
        {
          "@type": "Blog",
          "@id": "https://reachthepeople.ai/blogs#blog",
          name: "ReachThePeople.ai Blog",
          url: "https://reachthepeople.ai/blogs",
          publisher: { "@id": "https://reachthepeople.ai/#org" },
        },

        {
          "@type": "ItemList",
          "@id": "https://reachthepeople.ai/blogs#recent",
          name: "Recent blog posts",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              url: "https://reachthepeople.ai/blog/how-smart-campaigns-are-winning-with-less-outreach",
            },
            {
              "@type": "ListItem",
              position: 2,
              url: "https://reachthepeople.ai/blog/donors-ghosting-campaigns-fundraising-fix",
            },
            {
              "@type": "ListItem",
              position: 3,
              url: "https://reachthepeople.ai/blog/the-problem-with-one-size-fits-all-voter-messaging",
            },
            {
              "@type": "ListItem",
              position: 4,
              url: "https://reachthepeople.ai/blog/democrats-new-jersey-authenticity-ai",
            },
            {
              "@type": "ListItem",
              position: 5,
              url: "https://reachthepeople.ai/blog/voter-engagement-vs-ad-spend-2025",
            },
          ],
        },
      ],
    },
  },
  guidesPage: {
    title: "Guides for Campaigns & Nonprofits | ReachThePeople.ai",
    canonical: "https://reachthepeople.ai/guides",
    description:
      "Free, step-by-step guides for political campaigns, advocacy orgs, and nonprofits, covering planning, voter engagement, compliance & ethics, fundraising, field organizing, and more.",
    keywords:
      "campaign guides, political campaign guide, voter engagement guide, fundraising guide, field organizing, compliance and ethics, how to run for city council, school board guide, campaign management",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://reachthepeople.ai/#org",
          name: "ReachThePeople.ai",
          url: "https://reachthepeople.ai/",
        },
        {
          "@type": "WebSite",
          "@id": "https://reachthepeople.ai/#website",
          url: "https://reachthepeople.ai/",
          name: "ReachThePeople.ai",
          publisher: { "@id": "https://reachthepeople.ai/#org" },
          inLanguage: "en",
        },
        {
          "@type": "CollectionPage",
          "@id": "https://reachthepeople.ai/guides#webpage",
          url: "https://reachthepeople.ai/guides",
          name: "Guides for Campaigns & Nonprofits",
          description:
            "Free, step-by-step guides for political campaigns, advocacy orgs, and nonprofits—covering planning, voter engagement, compliance & ethics, fundraising, field organizing, and more.",
          isPartOf: { "@id": "https://reachthepeople.ai/#website" },
          inLanguage: "en",
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://reachthepeople.ai/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Guides",
                item: "https://reachthepeople.ai/guides",
              },
            ],
          },
          about: [
            { "@type": "Thing", name: "Political campaigns" },
            { "@type": "Thing", name: "Advocacy" },
            { "@type": "Thing", name: "Voter engagement" },
            { "@type": "Thing", name: "Fundraising" },
            { "@type": "Thing", name: "Compliance & ethics" },
            { "@type": "Thing", name: "Field organizing" },
          ],
          mainEntity: {
            "@type": "ItemList",
            name: "All Guides",
            itemListOrder: "http://schema.org/ItemListOrderAscending",
            numberOfItems: 9,
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Beginner’s Guide to Political Campaigns",
                url: "https://reachthepeople.ai/guide/beginners-guide-to-political-campaigns",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Ultimate Guide to Campaign Management",
                url: "https://reachthepeople.ai/guide/ultimate-guide-to-campaign-management",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Ultimate Guide for Presidential Campaigns",
                url: "https://reachthepeople.ai/guide/ultimate-guide-for-presidential-campaigns",
              },
              {
                "@type": "ListItem",
                position: 4,
                name: "Your Ultimate Guide to Voter Engagement",
                url: "https://reachthepeople.ai/guide/your-ultimate-guide-to-voter-engagement",
              },
              {
                "@type": "ListItem",
                position: 5,
                name: "The Ultimate Guide to Voter Segmentation",
                url: "https://reachthepeople.ai/guide/the-ultimate-guide-to-voter-segmentation",
              },
              {
                "@type": "ListItem",
                position: 6,
                name: "Your Ultimate Guide to Field Organizing",
                url: "https://reachthepeople.ai/guide/your-ultimate-guide-to-field-organizing",
              },
              {
                "@type": "ListItem",
                position: 7,
                name: "How to Run for City Council",
                url: "https://reachthepeople.ai/guide/how-to-run-for-city-council",
              },
              {
                "@type": "ListItem",
                position: 8,
                name: "How to Run for School Board and Local Office",
                url: "https://reachthepeople.ai/guide/how-to-run-for-school-board-and-local-office",
              },
              {
                "@type": "ListItem",
                position: 9,
                name: "Beginner’s Guide to Political Compliance & Ethics",
                url: "https://reachthepeople.ai/guide/beginners-guide-to-political-compliance-and-ethics",
              },
            ],
          },
        },
      ],
    },
  },
  userGuidePage: {
    title: "User Guide | ReachThePeople.ai",
    canonical: "https://reachthepeople.ai/resources/user-guide",
    description:
      "Complete user guide for ReachThePeople.ai — learn how to create AI-powered campaigns, connect your CRM, manage contacts, track analytics, and more.",
    keywords:
      "ReachThePeople user guide, campaign platform tutorial, AI outreach guide, political campaign software help, CRM integration guide, email campaign setup",
    og: {
      title: "User Guide | ReachThePeople.ai",
      description:
        "Everything you need to know about using ReachThePeople.ai — from getting started to advanced features.",
      url: "https://reachthepeople.ai/resources/user-guide",
      type: "website",
      siteName: "ReachThePeople.ai",
    },
    twitter: {
      title: "User Guide | ReachThePeople.ai",
      description:
        "Complete guide to AI-powered outreach and fundraising with ReachThePeople.ai.",
      card: "summary_large_image",
    },
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://reachthepeople.ai/resources/user-guide#webpage",
          url: "https://reachthepeople.ai/resources/user-guide",
          name: "User Guide",
          description:
            "Complete user guide for ReachThePeople.ai — learn how to create AI-powered campaigns, connect your CRM, manage contacts, and track analytics.",
          isPartOf: { "@id": "https://reachthepeople.ai/#website" },
          inLanguage: "en",
          breadcrumb: {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://reachthepeople.ai/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "User Guide",
                item: "https://reachthepeople.ai/resources/user-guide",
              },
            ],
          },
        },
      ],
    },
  },
  campaignProfessionalsPage: {
    title: "Join America's Top Political Directory| ReachThePeople.ai",
    canonical: "https://reachthepeople.ai/campaign-professionals",
    description:
      "Browse vetted professionals skilled in election strategy, outreach, and voter engagement.",
    keywords:
      "campaign professionals, political strategists,political consultants,Campaign communications professionals",
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://reachthepeople.ai/campaign-professionals#webpage",
          url: "https://reachthepeople.ai/campaign-professionals",
          name: "AI Tools for Campaign Professionals",
          description:
            "Solutions for political campaign managers, digital directors, and field teams: AI outreach, donor intelligence, and real-time supporter sentiment.",
          isPartOf: {
            "@type": "WebSite",
            "@id": "https://reachthepeople.ai/#website",
          },
          breadcrumb: {
            "@id":
              "https://reachthepeople.ai/campaign-professionals#breadcrumbs",
          },
          inLanguage: "en",
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://reachthepeople.ai/campaign-professionals#breadcrumbs",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://reachthepeople.ai/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Campaign Professionals",
              item: "https://reachthepeople.ai/campaign-professionals",
            },
          ],
        },
        {
          "@type": "Organization",
          "@id": "https://reachthepeople.ai/#org",
          name: "ReachThePeople.ai",
          url: "https://reachthepeople.ai/",
        },
        {
          "@type": "Service",
          "@id": "https://reachthepeople.ai/#campaign-service",
          serviceType:
            "AI campaigns, fundraising and supporter outreach platform",
          provider: { "@id": "https://reachthepeople.ai/#org" },
          areaServed: "US",
          audience: {
            "@type": "Audience",
            audienceType:
              "Political campaign professionals, advocacy organizations, nonprofits",
          },
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "USD",
            category: "Free trial",
          },
          isSimilarTo: {
            "@type": "WebPage",
            "@id": "https://reachthepeople.ai/guides#webpage",
          },
        },
      ],
    },
  },
};
